import apiClient from "./api";

export interface Expense {
  id?: number;
  referenceno: string;
  category_id?: number;
  category_code?: string;
  category_name?: string;
  name: string;
  description?: string;
  date: string;
  amount: number;
  status?: number;
  warehouse_id?: number;
  created_at?: string;
  updated_at?: string;
}

export interface ExpenseCategory {
  id?: number;
  code: string;
  name: string;
  description?: string;
  created_at?: string;
  updated_at?: string;
}

export interface ExpenseFilters {
  q?: string;
  search?: string;
  warehouse_id?: number | string;
  category_id?: number | string;
  status?: number | string;
  from_date?: string;
  to_date?: string;
}

const expenseService = {
  async getExpenses(params: ExpenseFilters = {}): Promise<Expense[]> {
    const response = await apiClient.get("/expences", { params });
    return response.data.data ?? response.data;
  },
  async getExpense(id: number): Promise<Expense> {
    const response = await apiClient.get(`/expences/${id}`);
    return response.data.data ?? response.data;
  },
  async createExpense(input: Expense): Promise<Expense> {
    const response = await apiClient.post("/expences", input);
    return response.data.data ?? response.data;
  },
  async updateExpense(id: number, input: Partial<Expense>): Promise<Expense> {
    const response = await apiClient.put(`/expences/${id}`, input);
    return response.data.data ?? response.data;
  },
  async deleteExpense(id: number): Promise<void> {
    await apiClient.delete(`/expences/${id}`);
  },
  async getNextReference(): Promise<string> {
    const response = await apiClient.get("/expences/next-reference");
    return response.data.data ?? response.data;
  },
  // Expense Categories
  async getExpenseCategories(): Promise<ExpenseCategory[]> {
    const response = await apiClient.get("/expencecategory");
    return response.data.data ?? response.data;
  },
  async createExpenseCategory(input: ExpenseCategory): Promise<ExpenseCategory> {
    const response = await apiClient.post("/expencecategory", input);
    return response.data.data ?? response.data;
  },
  async updateExpenseCategory(id: number, input: Partial<ExpenseCategory>): Promise<ExpenseCategory> {
    const response = await apiClient.put(`/expencecategory/${id}`, input);
    return response.data.data ?? response.data;
  },
  async deleteExpenseCategory(id: number): Promise<void> {
    await apiClient.delete(`/expencecategory/${id}`);
  }
};

export default expenseService;
